import * as angular from "angular";

angular
  .module('bringoz.admin.webhooks')
  .constant('Webhooks_PN', {
    database: 'webhooks',
    isBranchEntity: false
  });
